import * as types from "./types";
import { initialState } from "./initialState";

export default function limitReducer(state = initialState, action) {
  switch (action.type) {
    case types.API_STATUS:
      return {
        ...state,
        apiStatus: action.payload,
      };

    case types.GET_AUDIT:
      return {
        ...state,
        uoplist: action.payload,
      };

    case types.GET_CONFIG_AUDIT_TRAIL:
      return {
        ...state,
        configAuditTrailList: action.payload,
      };
    case types.GET_CONFIG_AUDIT_TRAIL_FILTERS:
      return {
        ...state,
        configAuditTrailFilters: action.payload,
      };
    case types.GET_CONFIG_VERSIONS:
      return {
        ...state,
        configVersions: action.payload,
      };

    default:
      return state;
  }
}
